@if (isCleaningService()) {
  <app-happy-helper-banner />
}

@if (vertical) {
  <div class="container">
    <div class="page_container">
      <!-- Breadcrumb above the hero: keyword-aligned internal links belong at
           the top of the page, in the SSR markup, before the H1. -->
      <div class="breadcrumb-list outer_seo_page_component_container">
        <div class="inner_seo_page_component_container">
          <app-breadcrumb-list
            [partsOfUrl]="partsOfUrl"
            [transparent]="true"
            [vertical]="true"
          />
        </div>
      </div>

      <app-hero-section
        [flushTop]="true"
        [vertical]="vertical"
        [heroImageUrl]="heroImgUrl"
        [heroImageAlt]="heroImgAlt"
        [isCityUrl]="isCityUrl"
        [cityOrRegionText]="cityOrRegionText"
        [isJobsPage]="isJobsPage"
        [noRelTasks]="noRelTasks"
        [q50Price]="q50Price"
        [url]="url"
        [isFindPage]="isFindPage"
        [hasAssociatedTasks]="hasAssociatedTasks"
        [hasFaqContent]="hasFaqContent"
        [hasPriceAndReview]="priceAndReviewRendered"
        [hasGoodToKnow]="hasGoodToKnow"
        [nationalUrl]="nationalUrl"
        [nationalLinkLabel]="nationalLinkLabel"
        [nationalLinkPageType]="nationalLinkPageType"
        (setGetQuote)="setGetQuote($event.value)"
        (openAuthDialog)="openAuthDialog()"
      />

      <!-- Deep Link Buttons -->
      @if (isFindPage && innerWidth >= 770) {
        <div
          class="deep-link-buttons-container-seo outer_seo_page_component_container"
        >
          <div class="inner_seo_page_component_container">
            <app-deep-link-buttons
              [buttons]="deepLinkButtons"
              [showScrollArrows]="true"
              [roundedCorners]="true"
            ></app-deep-link-buttons>
          </div>
        </div>
      }

      @if (!isNetherland) {
        <div class="trustpilot-desktop-widget-container">
          <app-trustpilot-widget></app-trustpilot-widget>
        </div>
      }

      @if (isFindPage) {
        <app-value-line></app-value-line>

        @if (
          vertical.tagId || vertical.city?.slug || vertical.region?.regionURL
        ) {
          <app-best-associated-users
            [vertical]="vertical"
            [isCityUrl]="isCityUrl"
            [cityOrRegionText]="cityOrRegionText"
            [reviewPriceShowing]="priceReviewShowing"
          ></app-best-associated-users>
        }
        @if (hasVertical && (vertical.dbTag || vertical.tagId)) {
          <app-price-and-review
            [vertical]="vertical"
            [q25Price]="q25Price!"
            [q50Price]="q50Price!"
            [q75Price]="q75Price!"
            [cityOrRegionText]="cityOrRegionText"
            [relTasks]="relTasks"
            [city]="city"
            [imgUrl]="heroImgUrl"
            (componentRendered)="onPriceAndReviewRendered($event)"
          />
        }

        <app-how-it-works
          [left_align]="true"
          [noButton]="true"
          [isVerticalPage]="true"
          [titleLabel]="verticalH1"
        />
      }

      <app-associated-tasks
        [vertical]="vertical"
        [isCityUrl]="isCityUrl"
        [relTasks]="relTasks"
        [cityOrRegionText]="cityOrRegionText"
        [isJobsPage]="isJobsPage"
      />

      @if (isJobsPage && hhJobEarnTitle) {
        <app-hh-seo-desc
          [hhSeoTitle]="hhJobEarnTitle"
          [hhSeoDesc]="jobEarnAsContent"
        />
      }

      @if (isFindPage) {
        <app-include-content [vertical]="vertical" />

        @if (!hasWhatItIncludesArea) {
          <div class="spacer_vertical"></div>
        }
      }

      <app-why-handyhand
        [isPinployeeVerticalPage]="isJobsPage"
        [titleLabel]="verticalH1"
      />

      @if (isJobsPage) {
        <app-insurance-usp />

        @if (hhJobIntroContent) {
          <app-hh-seo-desc
            [hhSeoTitle]="hhJobIntroTitle"
            [hhSeoDesc]="hhJobIntroContent"
          />
        }
      }

      <div class="spacer">
        <app-faq-content
          [vertical]="vertical"
          [isFindPage]="isFindPage"
          [isJobsPage]="isJobsPage"
        />
      </div>

      @if (vertical) {
        <app-good-to-know [vertical]="vertical" [content]="goodToKnowContent" />

        @if (hasAssociatedTasks) {
          <app-why-content
            [vertical]="vertical"
            [isCityUrl]="isCityUrl"
            [relTasks]="relTasks"
            [q25Price]="q25Price"
            [q50Price]="q50Price"
            [q75Price]="q75Price"
          />
        }

        <app-related-services [content]="relatedServicesContent" />
      }

      @if (!isJobsPage) {
        <div class="link_container_holder">
          <app-links-container
            [vertical]="vertical"
            [isJobsPage]="isJobsPage"
            [cityOrRegionText]="cityOrRegionText"
            [url]="url || ''"
            [verticalPage]="true"
          />
        </div>
      }
    </div>

    <app-lp-footer />

    @if (schema) {
      <div [innerHTML]="schema | jsonLd"></div>
    }
  </div>
}
